import * as React from 'react';
import cn from '~modules/cn';
import Styles from './layout.module.scss';

export type Props = {
    className?: string;
    children?: React.ReactNode;
};

export const Page = (props: Props) => <div className={cn(Styles.page, props.className)}>{props.children}</div>;

export const PageContainer = (props: Props) => <div className={cn(Styles.container, props.className)}>{props.children}</div>;
